module.exports = __webpack_public_path__ + "img/reviews-06.30a07894.png";